import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Gauge, Workflow, Globe, Wand2, Zap } from 'lucide-react';

const Benefits: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto mb-32">
      <h2 className="text-center mb-12">{t('benefits.title')}</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Shield className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.privacy.title')}</h3>
          <p>{t('benefits.privacy.description')}</p>
        </div>
        
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Gauge className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.speed.title')}</h3>
          <p>{t('benefits.speed.description')}</p>
        </div>
        
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Workflow className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.batch.title')}</h3>
          <p>{t('benefits.batch.description')}</p>
        </div>
        
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Globe className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.offline.title')}</h3>
          <p>{t('benefits.offline.description')}</p>
        </div>
        
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Wand2 className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.optimization.title')}</h3>
          <p>{t('benefits.optimization.description')}</p>
        </div>
        
        <div className="benefit-container">
          <div className="process-icon-container mb-4">
            <Zap className="process-icon" size={24} aria-hidden="true" />
          </div>
          <h3>{t('benefits.free.title')}</h3>
          <p>{t('benefits.free.description')}</p>
        </div>
      </div>
    </div>
  );
};

export default Benefits;